export default __webpack_public_path__ + "static/tea2-1898e9ed1aa8b2ef587808d8a0b32edc.png";